;( function( $, window, document ) {

    "use strict";

    // undefined is used here as the undefined global variable in ECMAScript 3 is
    // mutable (ie. it can be changed by someone else). undefined isn't really being
    // passed in so we can ensure the value of it is truly undefined. In ES5, undefined
    // can no longer be modified.

    // window and document are passed through as local variable rather than global
    // as this (slightly) quickens the resolution process and can be more efficiently
    // minified (especially when both are regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = "expander",
        defaults = {
            trigger: '.expander__trigger',
            target: '.expander__target',
            pane: '.expander__pane',
            closeAllOnToggle: false
        };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        // jQuery has an extend method which merges the contents of two or
        // more objects, storing the result in the first object. The first object
        // is generally empty as we don't want to alter the default options for
        // future instances of the plugin
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend( Plugin.prototype, {
        init: function() {
            var instance = this;

            for( var i in defaults ){
                this.settings[i] = $(this.element).attr('expander-'+i)  || this.settings[i];
            }

            instance._triggers = $(instance.element).find(this.settings.trigger);
            instance._targets = $(instance.element).find(this.settings.target);
            instance._panes = $(instance.element).find(this.settings.pane);
            instance._heights = [];

            var lengthWarn = instance._triggers.length ===
            instance._targets.length ? instance._triggers.length : false;

            if (lengthWarn === false) {
                console.warn('You\'re not providing an equal amount of triggers and targets');
                return;
            }

            instance._calculateHeights();
            instance._moveTargets();
            instance._addEventListeners();

            requestAnimationFrame(function() {
                $(instance.element).attr('active', '');
            });
        },
        _addEventListeners: function() {
            var instance = this;

            instance._triggers.on('click', function(evt) {
                instance._onTargetChange(evt);
            });
        },
        _onTargetChange: function(evt) {
            var instance = this;
            var pane = $(evt.target).closest(instance.settings.pane);

            if (instance.settings.closeAllOnToggle) {
                instance._panes.each(function() {
                    var pane = $(this);
                    pane.removeClass('is-open');
                });
            }
            pane.toggleClass('is-open');

            instance._moveTargets();
        },
        _calculateHeights: function() {
            var instance = this;

            if (instance._targets.length === 0) {
                console.warn('You\'re not providing any targets');
                return;
            }

            instance._targets.each(function() {
                var target = $(this);
                instance._heights.push(target[0].offsetHeight);
            });
        },
        _moveTargets: function() {
            var instance = this;

            instance._panes.each(function(index) {
                var pane = $(this);
                var target = $(this).find(instance.settings.target);

                target.css('height', 0);

                if (pane.hasClass('is-open')) {
                    target.css('height', instance._heights[index]);
                }
            });
        },
        callFunction: function (call, options) {
            if(typeof this[call] === 'function') {
                return this[call](options);
            }
        }
    } );

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[ pluginName ] = function(call, options ) {
        return this.each( function() {
            if ( !$.data( this, "plugin_" + pluginName ) ) {
                $.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
            } else {
                return $.data(this, "plugin_" + pluginName).callFunction(call, options);
            }
        } );
    };

    $(function () {
        $(document).find('[expander]').attr('enhanced', '');
        $(document).find('[expander]').expander();
    });

} )( jQuery, window, document );
